<section>
  <app-expert-group-portal-header
    *ngIf="expertGroupPortal"
    selectedNavItem="overview"
    [expertGroupPortal]="expertGroupPortal"
  ></app-expert-group-portal-header>

  <div
    class="container-full bg-media py-6"
    [ngClass]="{
      'is-ai-futures': expertGroupPortal.id === 'ai-futures',
      'is-compute-climate': expertGroupPortal.id === 'compute-climate',
      'is-risk-accountability': expertGroupPortal.id === 'risk-accountability',
      'is-incidents': expertGroupPortal.id === 'incidents',
      'is-health': expertGroupPortal.id === 'health',
      'is-data-privacy': expertGroupPortal.id === 'data-privacy'
    }"
  >
    <div class="container my-4" *ngIf="page && !loadingPage">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h2 class="title is-2 mb-5 has-text-white">Overview</h2>
          <div
            class="has-text-white"
            *ngIf="page && !loadingPage"
            [innerHTML]="page.text1"
          ></div>
        </div>
        <div class="column is-offset-1 is-5" *ngIf="page?.link1">
          <a
            (click)="isModalOpen = true"
            (keydown)="isModalOpen = true"
            tabindex="0"
            class="ghost flex align-center justify-start"
          >
            <figure class="position: relative">
              <img
                class="is-block"
                [src]="page.image1.sizes.videoCard"
                [alt]="'photo of ' + page.title"
              />
              <div class="video-layer">
                <i class="far fa-play-circle has-text-white is-size-1"></i>
              </div>
            </figure>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!page || loadingPage">
    <div class="mt-6 temporary-item temporary-item--dark temporary-desc"></div>
    <div class="temporary-item temporary-item--dark temporary-desc"></div>
    <div class="temporary-item temporary-item--dark temporary-desc"></div>
    <div class="temporary-item temporary-item--dark temporary-desc"></div>
    <div class="temporary-item temporary-item--dark temporary-desc"></div>
    <div class="temporary-item temporary-item--dark temporary-desc"></div>
    <div class="column is-3 is-offset-1">
      <div class="lc lc--regular">
        <div></div>
      </div>
    </div>
  </div>

  <!-- Discussions -->
  <div
    class="container-full mt-6"
    *ngIf="discussions?.length && !loadingDiscussions"
  >
    <div class="container p-y-xl">
      <div class="columns is-multiline">
        <div class="column is-12 is-fullheight">
          <div
            class="is-flex is-align-items-center is-justify-content-space-between"
          >
            <div class="media mb-0 is-fullwidth">
              <div class="media-left">
                <figure class="image is-32x32">
                  <div class="icon-wrapper mr-2">
                    <div class="has-background-primary-bis"></div>
                    <span class="icon is-size-6">
                      <i class="fas fa-comment" style="color: #2d9af7"></i>
                    </span>
                  </div>
                </figure>
              </div>
              <div class="media-content">
                <h2 class="title is-3 mt-1 mb-3">Discussions</h2>
              </div>
            </div>

            <a
              class="button is-link"
              routerLink="/site/{{ expertGroupPortal.id }}/discussions"
              >See all discussions</a
            >
          </div>
          <p class="mt-3 mb-5">
            Engage in dialogue with the OECD and others interested in
            {{ expertGroupPortal.title }}.
          </p>
        </div>
      </div>
      <div class="columns is-multiline">
        <div
          class="column is-12-touch is-4-desktop has-button-short"
          *ngFor="let discussion of discussions"
        >
          <app-discussion-card
            [discussion]="discussion"
            [expertGroupPortal]="expertGroupPortal"
          ></app-discussion-card>
        </div>
      </div>
    </div>
  </div>

  <!-- Loader Discussions -->
  <app-overview-discussion-loader
    *ngIf="loadingDiscussions"
  ></app-overview-discussion-loader>
  <!-- Experts -->
  <div
    class="container-full has-background-white-ter mt-6"
    *ngIf="authors?.length && !loadingAuthors"
  >
    <div class="container p-y-xl">
      <div class="columns is-multiline">
        <div class="column is-12 is-fullheight">
          <div
            class="is-flex is-align-items-center is-justify-content-space-between m-t-colgap"
          >
            <div class="media mb-0">
              <div class="media-left">
                <figure class="image is-32x32">
                  <div class="icon-wrapper mr-2">
                    <div class="has-background-link-bis"></div>
                    <span class="icon is-size-6">
                      <i class="fas fa-users has-text-link"></i>
                    </span>
                  </div>
                </figure>
              </div>
              <div class="media-content">
                <h2 class="title is-3 mt-1 mb-3">Experts</h2>
              </div>
            </div>

            <a
              class="button is-link"
              routerLink="/site/{{ expertGroupPortal.id }}/experts"
              >See all experts</a
            >
          </div>
          <p class="mt-3 mb-5">
            The Expert Group on {{ expertGroupPortal.title }} is comprised of
            multidisciplinary and cross-sector AI and foresight experts from
            around the world.
          </p>
          <h3 class="title is-5 mb-5">
            {{ expertGroupPortal.title }} Group Co-chairs
          </h3>
        </div>
      </div>
      <div class="columns is-multiline">
        <div
          class="column is-12-mobile is-4-tablet is-3-desktop has-background-white-ter"
          *ngFor="let author of authors"
        >
          <app-author-card
            [author]="author"
            [authorImage]="author.image"
          ></app-author-card>
        </div>
      </div>
    </div>
  </div>
  <!-- Loader Experts -->
  <app-overview-expert-loader
    *ngIf="loadingAuthors"
  ></app-overview-expert-loader>

  <!-- Resources -->
  <div class="container mt-6 bb-1" *ngIf="featuredCards?.length">
    <div class="columns">
      <div class="column is-12">
        <div
          class="is-flex is-align-items-center is-justify-content-space-between m-t-colgap"
        >
          <div class="media mb-0">
            <div class="media-left">
              <figure class="image is-32x32">
                <div class="icon-wrapper mr-2">
                  <div
                    class="has-background-light-purple bg-light-purple"
                  ></div>
                  <span class="icon is-size-6">
                    <i class="fas fa-users has-text-purple"></i>
                  </span>
                </div>
              </figure>
            </div>
            <div class="media-content">
              <h2 class="title is-3 mt-1 mb-3">Resources</h2>
            </div>
          </div>

          <a
            class="button is-link"
            routerLink="/site/{{ expertGroupPortal.id }}/publications"
            >More resources</a
          >
        </div>
      </div>
    </div>

    <app-featured-card-list
      [loading]="loadingFeaturedCards"
      [featuredCards]="featuredCards"
    ></app-featured-card-list>

    <div class="columns">
      <div class="column">
        <hr class="has-background-white-bis" />
      </div>
    </div>
  </div>

  <!-- Live News -->
  <div class="container" *ngIf="expertGroupPortal?.id === 'ai-futures'">
    <div class="columns">
      <div class="column is-6 is-offset-3">
        <h2 class="title is-3 m-t-colgap mb-5 p-t-gutter">Live news</h2>
        <iframe
          *ngIf="futuresAiNewsUrl"
          width="100%"
          style="height: 750px"
          [src]="futuresAiNewsUrl"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>

  <!-- Related posts -->
  <div
    class="container-full has-background-white-ter mt-6"
    *ngIf="page?.relatedPosts?.length"
  >
    <div class="container p-y-xl" *ngIf="!loadingRelatedPosts">
      <div class="columns">
        <div class="column is-12">
          <div
            class="is-flex is-align-items-center is-justify-content-space-between"
          >
            <h3 class="title is-3 has-tex-black m-t-colgap mb-3">
              From the AI Wonk
            </h3>
            <a
              class="button is-link"
              routerLink="/site/{{ expertGroupPortal.id }}/blog-posts"
              >More related posts</a
            >
          </div>
        </div>
      </div>
      <div class="columns flex flex-wrap">
        <div
          class="column is-12-mobile is-6-tablet is-4-desktop"
          *ngFor="let post of page.relatedPosts"
        >
          <app-post-card [post]="post"></app-post-card>
        </div>
      </div>
    </div>

    <!-- Related posts loader -->

    <div class="container" *ngIf="loadingRelatedPosts">
      <div class="columns flex flex-wrap">
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <div class="lc lc--white lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <div class="lc lc--white lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="column is-12-mobile is-6-tablet is-4-desktop">
          <div class="lc lc--white lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="page && !loadingPage">
    <div class="columns is-multiline">
      <div class="column is-12">
        <div class="content mt-6" [innerHTML]="page.richText1"></div>
      </div>
    </div>
  </div>
  <div *ngIf="!page || loadingPage">
    <div class="mt-6 temporary-item temporary-item--dark temporary-desc"></div>
    <div class="temporary-item temporary-item--dark temporary-desc"></div>
  </div>
</section>
<!-- Video modal -->
<div class="modal modal-large is-active" *ngIf="isModalOpen">
  <div class="modal-background"></div>
  <div class="modal-content">
    <iframe
      id="youtube-player"
      width="100%"
      height="500"
      style="height: 500px"
      [src]="videoUrl"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</div>
